import { browserAudioDeviceService } from "@/features/audio/adapters/browser/browser-audio-device.service";
import { browserCapabilityService } from "@/features/audio/adapters/browser/browser-capability.service";
import { browserPermissionService } from "@/features/audio/adapters/browser/browser-permission.service";
import { AudioStateStore } from "@/features/audio/services/audio-state.store";
import { DeviceManager } from "@/features/audio/services/device-manager.service";
import { PermissionManager } from "@/features/audio/services/permission-manager.service";

export const createAudioServices = () => {
    const stateStore = new AudioStateStore();
    const deviceManager = new DeviceManager(browserAudioDeviceService, stateStore);
    const permissionManager = new PermissionManager(browserPermissionService, browserCapabilityService, stateStore);

    return {
        stateStore,
        deviceManager,
        permissionManager,
    };
};

export type AudioServices = ReturnType<typeof createAudioServices>;

export const audioServices = createAudioServices();
